/**
 * All chessboard-defined actions on the context menu.
 */
export const CONTEXT_MENU_ACTION_NAMES = {
  AddAnnotation: 'AddAnnotation',
  AddComment: 'AddComment',
  AddCommentBefore: 'AddCommentBefore',
  DeleteCommentAfter: 'DeleteCommentAfter',
  DeleteCommentBefore: 'DeleteCommentBefore',
  AddAdditionalAnnotation: 'AddAdditionalAnnotation',
  HideAllAnnotations: 'HideAllAnnotations',
  ShowAllAnnotations: 'ShowAllAnnotations',
  RemoveAnnotation: 'RemoveAnnotation',
  DeleteVariation: 'DeleteVariation',
  PromoteVariation: 'PromoteVariation',
  DeleteMove: 'DeleteMove',
  ClearAnalysis: 'ClearAnalysis',
  InsertContinuation: 'InsertContinuation',
  MoveVariationUp: 'MoveVariationUp',
  MoveVariationDown: 'MoveVariationDown',
  // custom actions
  RemoveBegin: 'RemoveBegin',
  RemoveEnd: 'RemoveEnd',
  RemoveFocus: 'RemoveFocus',
  SetBegin: 'SetBegin',
  SetEnd: 'SetEnd',
  SetFocus: 'SetFocus',
};
